module.exports = __webpack_public_path__ + "img/bg.374a04af.svg";